import _isEmpty from 'lodash/isEmpty';
import fetch from 'cross-fetch';
import { getProperty } from '../modules/ajio-util/properties';
import { parseSearch } from '../modules/ajio-util/query';
// const sixHours = 6 * 60 * 60 * 1000
const sixHours = 5 * 60 * 1000;

const fetchRedirectFlags = () => {
  fetch('/api/isRedirect', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      originalUrl: window.location.pathname
    })
  })
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response);
      }
      return response.json();
    })
    .then(({ isRedirect, redirectUrl, started }) => {
      if (isRedirect && started) {
        window.location = redirectUrl;
      }
    })
    .catch(err => {
      console.log('Error in fetching Redirect Flags for sale', err);
    });
};

const callRedirect = (previewTime = 0, EndTime = 0) => {
  //  if(currentTime >= json.previewFlashSaleTime && currentTime <= json.flashSaleEndTime
  const currentTime = Date.now();
  const saleStarted = currentTime - previewTime;
  const saleEnded = EndTime - currentTime;
  if (previewTime && saleStarted && saleEnded) {
    fetchRedirectFlags();
  }
};
const fetchFlashSaleTime = () => {
  const currentTime = Date.now();
  const lastCalled = localStorage.getItem('lastFetchSaleTime');
  if (lastCalled && currentTime - lastCalled < sixHours) {
    const saleTime = JSON.parse(localStorage.getItem('saleTime') || '{}');
    const { previewFlashSaleTime, flashSaleEndTime } = saleTime;
    callRedirect(previewFlashSaleTime, flashSaleEndTime);
    return;
  }
  fetch('/api/getFlashsaleTime')
    .then(response => {
      if (!response.ok) {
        return Promise.reject(response);
      }
      return response.json();
    })
    .then(({ flashSaleEndTime, flashSaleStartTime, previewFlashSaleTime }) => {
      localStorage.setItem(
        'saleTime',
        JSON.stringify({
          previewFlashSaleTime,
          flashSaleStartTime,
          flashSaleEndTime
        })
      );
      localStorage.setItem('lastFetchSaleTime', Date.now());
      callRedirect(previewFlashSaleTime, flashSaleEndTime);
    })
    .catch(err => {
      console.log('Error in fetching flash sale time...', err);
    });
};

// const handleRedirect = () => {
//     const saleTime = JSON.parse(localStorage.getItem('saleTime') || '{}')
//     if(_isEmpty(saleTime)) {
//         fetchFlashSaleTime()
//     } else {
//         const {
//             previewFlashSaleTime,
//             flashSaleEndTime
//         } = saleTime
//         callRedirect(previewFlashSaleTime, flashSaleEndTime)
//     }
// }

export const createRedirectUri = queryString => {
  const hostname = window?.location?.hostname;
  let redirectURI = `https://${hostname}/`;
  if (hostname.includes('localhost')) {
    redirectURI = `${getProperty('parentUrl')}/`;
  }
  const queryObj = parseSearch(queryString);
  let referrer = queryObj?.referrer || '';
  if (
    referrer.includes('/search/') ||
    referrer.includes('/s/') ||
    referrer.includes('/c/') ||
    referrer.includes('/b/') ||
    referrer.includes('/fb/')
  ) {
    if (referrer.includes('query=')) {
      referrer = referrer.replaceAll('%', '%25');
      referrer = referrer.replaceAll(':', '%3A');
      referrer = referrer.replaceAll('&', '%26');
      referrer = referrer.replaceAll(',', '%2C');
    }
    if (queryObj?.text) {
      referrer = `${referrer}&text=${queryObj?.text}`;
    }
    if (queryObj?.gridColumns) {
      referrer = `${referrer}&gridColumns=${queryObj?.gridColumns}`;
    }
  }
  if (referrer.includes('/p/')) {
    const customerData = window.localStorage.getItem('customerTypeData');
    const parsedData = JSON.parse(customerData);
    const isExisting = parsedData?.customerType;
    if (isExisting === 'Existing') {
      referrer = `${referrer}?user=old`;
    }
  }
  if (referrer.includes('http')) {
    try {
      const parsedUrl = new URL(referrer);
      const trustedHostname = parsedUrl.hostname;
      if (
        trustedHostname === 'ajio.com' ||
        trustedHostname.endsWith('.ajio.com') ||
        trustedHostname === 'ajio.ril.com' ||
        trustedHostname.endsWith('.ajio.ril.com')
      ) {
        redirectURI = referrer;
      }
    } catch {
      // invalid URL — keep default redirectURI
    }
  } else {
    if (referrer.indexOf('/') === 0) {
      referrer = referrer.slice(1);
    }
    redirectURI = `${redirectURI}${referrer}`;
  }
  return redirectURI;
};

export const redirectOnAuthClose = queryString => {
  const hostname = window?.location?.hostname;
  let redirectURI = `https://${hostname}/`;
  if (hostname.includes('localhost')) {
    redirectURI = `${getProperty('parentUrl')}/`;
  }
  const queryObj = parseSearch(queryString);
  let referrer = queryObj?.referrer || '';
  if (referrer.includes('http')) {
    try {
      const parsedUrl = new URL(referrer);
      const trustedHostname = parsedUrl.hostname;
      if (
        trustedHostname === 'ajio.com' ||
        trustedHostname.endsWith('.ajio.com') ||
        trustedHostname === 'ajio.ril.com' ||
        trustedHostname.endsWith('.ajio.ril.com')
      ) {
        redirectURI = referrer;
      }
    } catch {
      // invalid URL — keep default redirectURI
    }
  } else if (!referrer.toLowerCase().includes('wishlist')) {
    if (referrer.indexOf('/') === 0) {
      referrer = referrer.slice(1);
    }
    if (!referrer.includes('jio-engage')) {
      redirectURI = referrer.includes('refer-and-earn')
        ? `${redirectURI}my-account/`
        : `${redirectURI}${referrer}`;
    }
  }
  return redirectURI;
};

export default fetchRedirectFlags;
